// from https://github.com/turuslan/HackTimer
// but tweaked to load service worker from dist for string CSP

const config = JSON.parse(document.getElementById('app-config').innerHTML) || { API_BASE_URL: 'https://localhost/api' }
// this is a complicated way of doing .replace('/api','/dist) which doesn't work here for some reason
const distroot = config.API_BASE_URL.slice(0, config.API_BASE_URL.indexOf('/api')) + '/dist';
(function(workerScript) {
  let worker
  const fakeIdToCallback = {}
  let lastFakeId = 0
  const maxFakeId = 0x7fffffff // 2 ^ 31 - 1, 31 bit, positive values of signed 32 bit integer
  const logPrefix = 'HackTimer.js by turuslan: '
  if (typeof Worker !== 'undefined') {
    function getFakeId() {
      do {
        if (lastFakeId == maxFakeId) {
          lastFakeId = 0
        } else {
          lastFakeId++
        }
      } while (fakeIdToCallback.hasOwnProperty(lastFakeId))
      return lastFakeId
    }
    try {
      worker = new Worker(workerScript)
      window.setInterval = function(callback, time /* , parameters */) {
        const fakeId = getFakeId()
        fakeIdToCallback[fakeId] = {
          callback: callback,
          parameters: Array.prototype.slice.call(arguments, 2)
        }
        worker.postMessage({
          name: 'setInterval',
          fakeId: fakeId,
          time: time
        })
        return fakeId
      }
      window.clearInterval = function(fakeId) {
        if (fakeIdToCallback.hasOwnProperty(fakeId)) {
          delete fakeIdToCallback[fakeId]
          worker.postMessage({
            name: 'clearInterval',
            fakeId: fakeId
          })
        }
      }
      window.setTimeout = function(callback, time /* , parameters */) {
        const fakeId = getFakeId()
        fakeIdToCallback[fakeId] = {
          callback: callback,
          parameters: Array.prototype.slice.call(arguments, 2),
          isTimeout: true
        }
        worker.postMessage({
          name: 'setTimeout',
          fakeId: fakeId,
          time: time
        })
        return fakeId
      }
      window.clearTimeout = function(fakeId) {
        if (fakeIdToCallback.hasOwnProperty(fakeId)) {
          delete fakeIdToCallback[fakeId]
          worker.postMessage({
            name: 'clearTimeout',
            fakeId: fakeId
          })
        }
      }
      worker.onmessage = function(event) {
        const data = event.data
        const fakeId = data.fakeId
        let request
        let parameters
        let callback
        if (fakeIdToCallback.hasOwnProperty(fakeId)) {
          request = fakeIdToCallback[fakeId]
          callback = request.callback
          parameters = request.parameters
          if (request.hasOwnProperty('isTimeout') && request.isTimeout) {
            delete fakeIdToCallback[fakeId]
          }
        }
        if (typeof callback === 'string') {
          try {
            callback = new Function(callback)
          } catch (error) {
            console.log(
              logPrefix + 'Error parsing callback code string: ',
              error
            )
          }
        }
        if (typeof callback === 'function') {
          callback.apply(window, parameters)
        }
      }
      worker.onerror = function(event) {
        console.log(event)
      }
    } catch (error) {
      console.log(logPrefix + 'Initialisation failed')
      console.error(error)
    }
  } else {
    console.log(
      logPrefix + 'Initialisation failed - HTML5 Web Worker is not supported'
    )
  }
})(distroot + '/HackTimerWorker.js')
